import { makeAutoObservable } from "mobx";
import { IExampleAnswerInfo } from "@repositories/model/transfer/IExampleAnswerInfo";
import { stores } from "../../../../../stores";

class TempExampleAnswerStore {
  private static instance: TempExampleAnswerStore;
  private exampleAnswers: IExampleAnswerInfo[] = [];

  /*
// ✅ Create an array with a single `IExampleAnswerInfo` object
            const exampleAnswers: IExampleAnswerInfo[] = [
                {
                    examCode: examCode,
                    questionNum: questionNum,
                    exampleAnswer: answer
                }
            ];
            */
  private constructor() {
    makeAutoObservable(this);
  }

  public static getInstance(): TempExampleAnswerStore {
    if (!TempExampleAnswerStore.instance) {
        TempExampleAnswerStore.instance = new TempExampleAnswerStore();
    }
    return TempExampleAnswerStore.instance;
  }

  // ✅ Add or update a sample in the array
  setExampleAnswer(examCode: string, questionNum: number, answer: string) {

    const index = this.exampleAnswers.findIndex(
      (s) => s.examCode === examCode && s.questionNum === questionNum
    );

    if (index !== -1) {
      // ✅ Update existing sample
      this.exampleAnswers[index].exampleAnswer = answer;
    } else {
      // ✅ Add new sample
      const exampleAnswerInfo: IExampleAnswerInfo = {
            examCode: examCode,
            questionNum: questionNum,
            exampleAnswer: answer
        };

      this.exampleAnswers.push(exampleAnswerInfo);
    }

  }
  
  async save() {
    await Promise.all(
        this.exampleAnswers.map(info =>
          stores.projectExamStore.updateCorrectedAnswer(
            info.examCode,
            info.questionNum,
            info.exampleAnswer
          )
        )
    );
  }

  clearAll() {
    this.exampleAnswers = [];
  }
  
}


export const tempExampleAnswerStore = TempExampleAnswerStore.getInstance(); 